import React from 'react';
import { ADD_ENTITY } from '@applyboard/ab-common';
import { raiseErrorMessage } from '@applyboard/ui-utils';
import { useCreateApplicationRequirement } from "../../data/requirements";
import { Classifications } from "../../data/requirementClassifications";
import { LegacyRequirementModal } from "../../components/RequirementModal";
import useDispatch from "../../hooks/useDispatch";
export function CreateRequirementModal(props) {
  var _useCreateApplication = useCreateApplicationRequirement(),
    createApplicationRequirement = _useCreateApplication.createApplicationRequirement,
    isCreatingApplicationRequirement = _useCreateApplication.isCreatingApplicationRequirement;
  var dispatch = useDispatch();
  return /*#__PURE__*/React.createElement(LegacyRequirementModal, {
    open: props.open,
    onClose: props.onClose,
    onSubmit: function onSubmit(requirement) {
      createApplicationRequirement({
        applicationId: props.applicationId,
        requirement: requirement
      }, {
        onSuccess: function onSuccess(results) {
          /**
           * Need to update the redux-bees store with new results.  Hopefully
           * we can convert this to react-query at some point and this won't
           * be necessary
           */
          dispatch({
            type: ADD_ENTITY,
            entity: results.legacyResponse.data,
            included: results.legacyResponse.included
          });
          if (props.onSuccess) {
            props.onSuccess();
          }
        },
        onError: function onError(err) {
          if (err instanceof Error) {
            raiseErrorMessage(err.message);
          }
        }
      });
    },
    saving: isCreatingApplicationRequirement,
    hiddenRequirementTypes: ['payment', 'hybrid'],
    defaultValues: {
      classification: props.tab === 'actions' ? Classifications.ACTION_REQUIREMENTS : Classifications.APPLICANT_REQUIREMENTS
    },
    lockedFields: ['earlyAccess', 'plagiarism']
  });
}